import { CrudRouter, SimpleUploader, DataList, TreeCrud, AutoRouter, Tree } from "javaee-fre";

const ClazzruleRepo = () => import("../views/clazzrule-repo.vue");
const ClazzArticleEditor = () => import("../views/clazz-article-editor.vue");
const ClazzChart = () => import("../views/clazz-chart.vue");

const ExportStatusViewer = () => import("../components/export-status-viewer.vue");

const DialogInput = () => import("../components/dialog-input.vue");
const RowFlag = () => import("../components/row-flag.vue");
const RatingFeedback = () => import("../components/rating-feedback.vue");

const LangSettings = () => import("../views/lang-settings.vue");

const ClazzUnFinishedStu = () => import("../views/clazz-unfinished-stu.vue");

const DialogTop = () => import("../components/dialog-top.vue");

const ClazzQrCode = () => import("../components/clazz-qrcode.vue");

const DialogConfirmCheckbox = () => import("../components/dialog-confirm-checkbox.vue");

import Colors from 'vuetify/es5/util/colors';

import { orgTree } from "./comm-func.js";

function colors() {
    let tmp = [], keys = Object.keys(Colors);
    for (let k of keys) {
        if (k == 'black' || k == 'grey') {
            continue;
        }
        let top = Colors[k];
        for (let c in top) {
            if (c.indexOf('darken') == 0 || c.indexOf('base') == 0) {
                tmp.push(top[c]);
            }
        }
    }
    return tmp;
}

function clazzCrudMeta(iGl, readOnly) {
    function writable() {
        return !readOnly && (iGl ? (!this.$store.state.account.orgId) : true);
    }
    return {
        createable: writable,
        editable: writable,
        deleteable: writable,
        listActions: readOnly ? [] : [{
            label: '导出', func() {
                let self = this, sd = self.searchData || {};
                window.open(`${self.$const.baseUrl}/home/admin/my/tenant/clazz/export.xlsx?_global=${iGl}&${self.$qs.stringify(sd)}`, '_blank');
            }
        }],
        listItemActions() {
            let self = this, acts = [], rt = readOnly ? (iGl ? 'g_ro_clazz' : 'ro_clazz') : (iGl ? 'g_clazz' : 'clazz');
            acts.push({
                label: '学员管理', icon: 'group', func(cfg) {
                    let self = this;
                    self.$router.push(`/console/home/admin/my/tenant/${rt}/stu/${cfg.item.id}/${cfg.item.archived || false}/${self.$dictVal(cfg.item.trackType)}`, `学员管理 - ${cfg.item.name}`);
                }
            }, {
                label: '统计分析', icon: 'bar_chart', func(cfg) {
                    let self = this;
                    self.$router.push(`/console/home/admin/my/tenant/${rt}/stats/${cfg.item.id}`, `统计分析 - ${cfg.item.name}`);
                }
            }, {
                label: '培训方案', icon: 'calendar_today', func(cfg) {
                    this.$dialog.component(cfg.item.name + '培训方案', "clazzrule-view", { targetId: this.$dictVal(cfg.item.ruleId), fullscreen: true });
                }
            }, {
                label: '评论管理', icon: 'comment', func(cfg) {
                    let self = this;
                    self.$router.push(`/console/home/admin/my/tenant/${rt}/comment/${cfg.item.id}`, `评论管理 - ${cfg.item.name}`);
                }
            }, {
                label: '评价反馈', icon: 'star_border', func(cfg) {
                    let self = this;
                    self.$axios.get(`/home/admin/my/tenant/clazz/rating/tags/${cfg.item.id}`).then(r => {
                        if (r.data.status == 'ok' && r.data.message) {
                            self.$dialog.component(`${cfg.item.name} - 评价反馈`, RatingFeedback, { width: 600, id: cfg.item.id, result: r.data.message });
                            return;
                        }
                        self.$status('没有评价反馈', 'success');
                    });
                }
            });
            if (!self.$store.state.account.orgId || !iGl) {//如果是根用户，或者不是全局计划
                if (!readOnly) {
                    acts.push({
                        label: '禁用', icon: 'visibility_off', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/clazz/disabled/${cfg.item.id}/${cfg.item.disabled === false ? true : false}`).then((r) => {
                                if (r.data && r.data.status == 'ok') {
                                    self.$status('操作成功！', 'success');
                                    self.refresh();
                                    return;
                                }
                                self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                            });
                        }
                    }, {
                        label: '考试设置', icon: 'book', func(cfg) {
                            let self = this;
                            self.$dialog.crud(`考试设置 - ${cfg.item.name}`, {
                                url: '/home/admin/my/tenant/clazz/quiz/settings', params: { _clazzId: cfg.item.id }
                            });
                        }
                    }, {
                        label: '提交审核', icon: 'publish', confirm: '确认要提交审核吗？', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/clazz/upward/${cfg.item.id}`).then(() => {
                                self.refresh();
                            });
                        }
                    });
                }
                acts.push({
                    label: '阅读管理', icon: 'chrome_reader_mode', func(cfg) {
                        let self = this;
                        self.$router.push(`/console/home/admin/my/tenant/${rt}/article/${cfg.item.id}/${cfg.item.archived || false}`, `阅读管理 - ${cfg.item.name}`);
                    }
                }, {
                    label: '设置阅读必学', icon: 'phonelink', confirm: '确认设置吗？', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/update/read/join/exam/${cfg.item.id}/${cfg.item.readJoinExam ? 'false' : 'true'}`).then(() => {
                            self.refresh();
                            self.$status('操作成功！', 'success');
                        });
                    }
                }, {
                    label: '置顶', icon: 'arrow_upward', func(cfg) {
                        let self = this;
                        if (!cfg.item.topTimestamp) {
                            self.$axios.get(`/home/admin/my/tenant/clazz/update/top/${cfg.item.id}/true`).then(() => {
                                self.refresh();
                                self.$status('操作成功～', 'success');
                            });
                            return;
                        }
                        self.$dialog.component('置顶设置', DialogTop, { width: 600 }, [{
                            label: '确认', color: 'primary', func(e) {
                                let params = 'true';
                                if (!e.checkedTop) {
                                    if (!e.forwardNum) {
                                        self.$status('请设置移动多少位', 'error');
                                        return;
                                    }
                                    params = e.forward ? 'true' : 'false' + '?step=' + e.forwardNum;
                                }

                                self.$axios.get(`/home/admin/my/tenant/clazz/update/top/${cfg.item.id}/${params}`).then(() => {
                                    self.refresh();
                                    self.$status('操作成功～', 'success');
                                });
                            }
                        }]);

                    }
                }, {
                    label: '取消置顶', icon: 'arrow_downward', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/update/top/${cfg.item.id}/false`).then(() => {
                            self.refresh();
                            self.$status('操作成功～', 'success');
                        });
                    }
                });
            }

            if (iGl && !self.$store.state.account.orgId && !readOnly) {
                acts.push({
                    label: '分配机构', icon: 'assignment', func(cfg) {
                        let self = this;
                        self.$router.push(`/console/home/admin/my/tenant/g_clazz/ctrl/${cfg.item.id}/${cfg.item.archived || false}`, `分配机构 - ${cfg.item.name}`);
                    }
                }, {
                    label: '复制培训计划', icon: 'content_copy', func(cfg) {
                        let self = this;
                        self.$dialog.crud(`复制培训计划 - ${cfg.item.name}`, {
                            url: '/home/admin/my/tenant/clazz', params: { _copy: true, _global: iGl }, editable: true, initPanel: 'edit', targetId: cfg.item.id,
                            onSaveSuccess() {
                                self.$dialog.close();
                                self.refresh();
                            }
                        });
                    }
                });
            }

            //超级管理员的权限
            if (self.$isSuperman() && !readOnly) {
                acts.push({
                    label: '启动强制初始照片对比', confirm: '确定启动吗？', icon: 'mood', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/update/face/force/${cfg.item.id}/true`).then(() => {
                            self.refresh();
                        });
                    }
                }, {
                    label: '禁用强制初始照片对比', confirm: '确定禁用吗？', icon: 'mood_bad', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/update/face/force/${cfg.item.id}/false`).then(() => {
                            self.refresh();
                        });
                    }
                }, {
                    label: '设置有效补签时长', icon: 'timer', func(cfg) {
                        let self = this;
                        self.$parent.onEdit(cfg.item.id, { _rsid: true });
                    }
                }, {
                    label: '设置最小签到签退时长', icon: 'timer', func(cfg) {
                        let self = this;
                        self.$dialog.component('设置最小签到签退时长', DialogInput, { width: 400, label: '请输入时长（单位：秒）', messages: ['不限制可以输入 0'] }, [{
                            label: '确认', color: 'primary', func(c) {
                                if (c && c.val && c.val.length > 0) {
                                    self.$axios.get(`/home/admin/my/tenant/clazz/set/min_dur_of_s/${cfg.item.id}/${c.val}`).then(() => {
                                        self.refresh();
                                        self.$status('设置成功～', 'success');
                                    });
                                }
                            }
                        }]);
                    }
                }, {
                    label: '归档', confirm: '确认要归档吗？', icon: 'archive', func(cfg) {
                        let self = this;
                        if (self.$store.state.loading.show) {
                            self.$status('请稍后归档～', 'error');
                            return;
                        }
                        self.$loading('正在归档请不要做其它操作～');
                        self.$axios.get(`/home/admin/sys/clazz/archive/${cfg.item.id}/true`).then(r => {
                            self.$loading();
                            let ok = r.data.status == 'ok';
                            self.$status(ok ? '归档成功' : (r.data.message || '归档出现错误'), ok ? 'success' : 'error');
                            self.refresh();
                        });
                    }
                }, {
                    label: '取消归档', confirm: '确认要取消归档吗？', icon: 'cancel', func(cfg) {
                        let self = this;
                        if (self.$store.state.loading.show) {
                            self.$status('请稍后归档～', 'error');
                            return;
                        }
                        self.$loading('正在取消归档请不要做其它操作～');
                        self.$axios.get(`/home/admin/sys/clazz/archive/${cfg.item.id}/false`).then(r => {
                            self.$loading();
                            let ok = r.data.status == 'ok';
                            self.$status(ok ? '取消归档成功' : (r.data.message || '取消归档出现错误'), ok ? 'success' : 'error');
                            self.refresh();
                        });
                    }
                }, {
                    label: '刷新统计信息', icon: 'refresh', func(cfg) {
                        let self = this;
                        self.$loading('正在刷新培训计划的统计，请不要做其它操作～');
                        self.$axios.get(`/home/admin/sys/clazz/cal/summary/${cfg.item.id}`).then(r => {
                            self.$loading();
                            let ok = r.data.status == 'ok';
                            self.$status(r.data.message, ok ? 'success' : 'error');
                            self.refresh();
                        });
                    }
                }, {
                    label: '语言设置', icon: 'language', func(cfg) {
                        this.$dialog.component(`语言设置 - ${cfg.item.name}`, LangSettings, {
                            width: 800, fields: [
                                { category: 3, categoryId: cfg.item.id, type: 1, targetId: 0, label: '名称' },
                                { category: 3, categoryId: cfg.item.id, type: 2, targetId: 0, label: '培训计划备注/提醒', textarea: true }
                            ]
                        });
                    }
                }, {
                    label: '设置为推荐', icon: 'star_border', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/set/recommend/${cfg.item.id}/${cfg.item.recommend ? 'false' : 'true'}`).then(() => {
                            self.$status('推荐设置成功～', 'success');
                            self.refresh()
                        })
                    }
                });
                if (iGl && !this.$store.state.account.orgId) {
                    acts.push({
                        label: '清除行政区划', icon: 'location_off', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/clazz/region/${cfg.item.id}/__0`).then(() => {
                                self.$status('清除成功～', 'success');
                                self.refresh()
                            })
                        }
                    }, {
                        label: '设置行政区划', icon: 'add_location', func(cfg) {
                            let self = this;
                            self.$dialog.component(`选择行政区划 - ${cfg.item.name}`, Tree, {
                                width: 400,
                                label(i) { return i.name; },
                                id(i) { return i.id },
                                hasChildren(i) { return !i.leaf },
                                url(i) {
                                    return `/p/lbs/district/${i ? i.id : 0}`;
                                }
                            }, [
                                {
                                    label: '确认设置', color: 'primary', func(sel) {
                                        if (!sel || !sel.active || sel.active.length < 1) { return }
                                        self.$loading('正在设置行政，请不要做其他操作～');
                                        self.$axios.get(`/home/admin/my/tenant/clazz/region/${cfg.item.id}/${sel.active[0].id}`).then(() => {
                                            self.$loading();
                                            self.$status('设置成功～', 'success');
                                            self.refresh();
                                        });
                                    }
                                }
                            ]);
                        }
                    });
                }
            }

            acts.push({
                label: '分享二维码', icon: 'share', func(cfg) {
                    let self = this;
                    self.$dialog.component(`${cfg.item.name}分享二维码`, ClazzQrCode, { clazzId: cfg.item.id, width: 500 });
                }
            });

            return acts;
        },
        onEditSelect(e, edit) {
            let self = this;
            if (e.field != 'ruleId') {
                return;
            }
            if (edit) {
                self.$dialog.crud('选择培训方案', { url: '/home/my/favorite', params: { _type: 6 }, selectStyle: 'single' }, [{
                    label: '确认', color: 'primary', func(sel) {
                        if (sel) {
                            let keys = Object.keys(sel);
                            if (keys.length > 0) {
                                let o = sel[keys[0]];
                                e.cb(o.name, o.targetId);
                            }
                        }
                    }
                }]);
            } else {
                self.$dialog.component('选择培训方案', ClazzruleRepo, { selectStyle: 'single' }, [{
                    label: '确认', color: 'primary', func(sel) {
                        if (sel) {
                            let keys = Object.keys(sel);
                            if (keys.length > 0) {
                                let o = sel[keys[0]];
                                e.cb(o.name, o.id);
                            }
                        }
                    }
                }]);
            }
        },
        listItemFilter(i, acts) {
            let self = this;
            if (!self.$store.state.account.delClazz && i.stuCount && i.stuCount > 0) {
                self.delAction(acts, "__tag", "delete");
            }
            if (!i.rating) {
                self.delAction(acts, 'icon', 'star_border');
            }
            if (i.trackType != 3) {
                self.delAction(acts, "icon", "timer");
            }

            if (i.recommend) {
                acts.find(a => a.icon == "star_border").label = "取消推荐";
            }

            if (i.archived) {//如果归档状态下，取消修改相关的所有操作
                self.delAction(acts, 'icon', 'star_border');
                self.delAction(acts, 'icon', 'visibility_off');
                self.delAction(acts, "icon", "book");
                self.delAction(acts, "icon", "publish");
                self.delAction(acts, "icon", "phonelink");
                self.delAction(acts, "icon", "arrow_upward");
                //self.delAction(acts, "icon", "arrow_downward");
                self.delAction(acts, "icon", "mood");
                self.delAction(acts, "icon", "mood_bad");
                self.delAction(acts, "icon", "timer");
                self.delAction(acts, "__tag", "edit");
                self.delAction(acts, "icon", "archive");
                self.delAction(acts, "icon", "cloud_queue");
                return acts;
            } else {
                self.delAction(acts, "icon", "cancel");
            }

            if (!i.topTimestamp) {
                self.delAction(acts, "icon", "arrow_downward");
            }

            if (i.readJoinExam) {
                let act = acts.find(a => a.icon == "phonelink");
                if (act) {
                    act.icon = "phonelink_off";
                    act.label = "设置阅读非必学";
                }
            }

            if (readOnly) {
                return acts;
            }

            if (self.$dictVal(i.startMode) != 1) {
                self.delAction(acts, "icon", "content_copy");
            }

            //如果priceStatus不为undefined，说明是在收费模式下
            let canPub = true, pStatus = self.$dictVal(i.priceStatus);
            if (pStatus !== undefined) {
                if (pStatus !== 2) {
                    self.delAction(acts, "icon", "visibility_off");
                    canPub = false;
                }
                if (pStatus != 0 && pStatus != 3) {
                    self.delAction(acts, "icon", "publish");
                }
            } else {
                self.delAction(acts, "icon", "publish");
            }

            if (canPub && i.disabled === true) {
                let act = acts.find(a => a.icon == "visibility_off");
                act.icon = "done";
                act.label = "启用";
            }

            if (self.$isSuperman()) {
                if (self.$dictVal(i.faceRecog)) {
                    self.delAction(acts, "icon", i.forceRawHead ? "mood" : "mood_bad");
                } else {
                    self.delAction(acts, "icon", "mood");
                    self.delAction(acts, "icon", "mood_bad");
                }
                if (!i.trackType || self.$dictVal(i.trackType) != 3) {
                    self.delAction(acts, "icon", "timer");
                }

                if (!i.region) {
                    self.delAction(acts, "icon", "location_off");
                }
            } else {
                self.delAction(acts, "icon", "cloud_queue");
            }
            return acts;
        },
        onEditFieldChange(fn, val, label) {
            let self = this;
            if (fn == 'ruleId' && label) {
                let nameVal = self.getFieldValue('name');
                if (!nameVal) {
                    self.setFieldValue('name', label);
                }
                return;
            }

            if (fn == 'startDate') {
                let sdv = self.getFieldValue('startDate');
                if (sdv && !self.getFieldValue('flag')) {
                    sdv = sdv.split('-').slice(0, 2).join('');
                    self.setFieldValue('flag', sdv);
                }
                return;
            }
        }
    };
}

function stuClazzCrudMeta(iGl, org, archived, readonly, trackLog) {
    archived = archived == 'true';
    let url = `/home/admin/my/tenant/clazz/${archived ? 'a_' : ''}stu`, cfg = {
        url: url,
        name: '学员管理', editable: false, refreshable: false, createable: false, selectStyle: 'multi',
        params: { _orgId: org ? org.id : null },
        titleField: '_name',
        listActions() {
            let self = this, readOnly = readonly || archived, a = self.$store.state.account,
                isTenantSuper = self.$isInRole('ROLE_TENANT_SUPER'),
                canDelay = (isTenantSuper || self.$isInRole('ROLE_TENANT_SC_DELAY')) && !archived,
                canOpen = (isTenantSuper || self.$isInRole('ROLE_TENANT_SC_OPEN')), acts = [{
                    whereSel: false,
                    label: '导出', func() {
                        let self = this, count = self.total;
                        if (count <= self.$const.LAZY_TASK_THRESHOLD) {
                            if (self.searching) {
                                window.open(`${self.$const.baseUrl}${url}/export/search/summary/1?${self.$qs.stringify(self.searchData())}` + `&_count=${count}&_clazzId=${self.cfg.params._clazzId}` + (org ? `&_orgId=${org.id}` : ''));
                            } else {
                                window.open(`${self.$const.baseUrl}${url}/export/summary/1?_clazzId=${self.cfg.params._clazzId}&_count=${count}` + (org ? `&_orgId=${org.id}` : ''));
                            }
                            return;
                        }
                        let params = { _clazzId: self.cfg.params._clazzId, _count: count };
                        if (self.searching) {
                            Object.assign(params, self.searchData());
                        }
                        self.$axios.get(`${url}/export/${self.searching ? 'search/' : ''}summary/1`, { params: params }).then(r => {
                            if (r.data.status == 'ok') {
                                self.$status(r.data.message, 'success');
                                self.$store.commit('rightDrawer', 'myTaskShow');
                                return;
                            }
                            self.$status(r.data.message, 'error');
                        });
                    }
                }];
            if (canDelay) {
                acts.push({
                    whereSel: true, label: '延期', func() {
                        let self = this, sel = self.selected();
                        if (sel) {
                            sel = Object.keys(sel);
                        }
                        if (!sel || sel.length == 0) {
                            self.$status('请选择需要延期的学员', 'error');
                            return;
                        }
                        self.$dialog.date('选择结束日期', {}, [{
                            label: '确认', color: 'primary', func(date) {
                                if (date) {
                                    self.$axios.get(`/home/admin/my/tenant/stuclz/delay/update/et/byid/${self.cfg.params._clazzId}/${sel.join('_')}/${date}`).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.$status('操作成功', 'success');
                                                self.refresh(false, true);
                                            } else {
                                                self.$status(r.data.message || "操作失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }
                        }]);
                    }
                }, {
                    whereSel: false, label: '延期未完成', func() {
                        self.$dialog.date('选择结束日期', {}, [{
                            label: '确认', color: 'primary', func(date) {
                                if (date) {
                                    self.$axios.get(`/home/admin/my/tenant/stuclz/delay/update/et/byclz/${self.cfg.params._clazzId}/${date}`, {
                                        params: {
                                            _orgId: org ? org.id : null, _noPass: true
                                        }
                                    }).then(() => {
                                        self.refresh();
                                        self.$status('设置完成～', 'success');
                                    });
                                }
                            }
                        }]);
                    }
                }, {
                    whereSel: false, label: '延期全部', func() {
                        self.$dialog.date('选择结束日期', {}, [{
                            label: '确认', color: 'primary', func(date) {
                                if (date) {
                                    self.$axios.get(`/home/admin/my/tenant/stuclz/delay/update/et/byclz/${self.cfg.params._clazzId}/${date}`, {
                                        params: {
                                            _orgId: org ? org.id : null
                                        }
                                    }).then(() => {
                                        self.refresh();
                                        self.$status('设置完成～', 'success');
                                    });
                                }
                            }
                        }]);
                    }
                });
            }
            if (!readOnly) {
                acts.push({
                    whereSel: true,
                    label: '标记',
                    func() {
                        let self = this, sel = self.selected();
                        if (sel) {
                            sel = Object.keys(sel);
                        }
                        if (!sel || sel.length == 0) {
                            self.$status('请选择要标记的学员', 'error');
                            return;
                        }
                        self.$axios.get(`${url}/tags`).then(r => {
                            let tags = r.data.message;
                            if (!tags || tags.length == 0) {
                                self.$status('目前没有标记字典无法对学员进行标记', 'error');
                                return;
                            }

                            self.$dialog.select('标记学员', { width: 400, items: tags, itemLabel: 'name', itemVal: 'id' }, [{
                                label: '确认', color: 'primary', func(tagId) {
                                    if (tagId) {
                                        self.$axios.get(`${url}/flag/tag/${sel.join('_')}/${tagId}`, { params: { _clazzId: self.cfg.params._clazzId, _orgId: org ? org.id : null } }).then(() => {
                                            self.refresh(false, true);
                                            self.$status('标记完成', 'success');
                                        });
                                    }
                                }
                            }]);
                        });
                    }
                });
                if (!iGl || !a.orgId) {
                    acts.push({
                        whereSel: true,
                        label: '分组',
                        func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                sel = Object.keys(sel);
                            }
                            if (!sel || sel.length == 0) {
                                self.$status('请选择要分组的学员', 'error');
                                return;
                            }

                            self.$dialog.component('学员分组', DialogInput, { width: 400, label: '请输入分组名称' }, [{
                                label: '确认', color: 'primary', func(c) {
                                    if (c && c.val && c.val.length > 0) {
                                        self.$axios.get(`${url}/flag/group`, { params: { _clazzId: self.cfg.params._clazzId, ids: sel.join('_'), group: c.val } }).then(() => {
                                            self.refresh(false, true);
                                            self.$status('分组完成', 'success');
                                        });
                                    }
                                }
                            }]);
                        }
                    }, {
                        whereSel: true,
                        label: '取消分组',
                        func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                sel = Object.keys(sel);
                            }
                            if (!sel || sel.length == 0) {
                                self.$status('请选择要删除分组的学员', 'error');
                                return;
                            }
                            self.$axios.get(`${url}/clear/group`, { params: { _clazzId: self.cfg.params._clazzId, ids: sel.join('_') } }).then(() => {
                                self.refresh(false, true);
                                self.$status('取消分组完成', 'success');
                            });
                        }
                    });
                }

                if (self.$isSuperman()) {
                    acts.push({
                        whereSel: true,
                        label: '批量删除',
                        confirm: '确定删除吗？',
                        func() {
                            let self = this, sel = self.selected();
                            if (sel) {
                                sel = Object.keys(sel);
                            }
                            if (!sel || sel.length == 0) {
                                self.$status('请选择要删除的学员', 'error');
                                return;
                            }

                            self.$axios.get(`${url}/delete/batch/${sel.join('_')}`).then(r => {
                                if (r.data) {
                                    if (r.data.status == "ok") {
                                        self.$status('操作成功', 'success');
                                        self.refresh(false, true);
                                        self._onListSelAll(false);
                                    } else {
                                        self.$status(r.data.message || "操作失败！", 'error');
                                    }
                                }
                            });
                        }
                    }, {
                        label: '计算学习进度', func() {
                            let self = this, params = { _clazzId: self.cfg.params._clazzId, _orgId: org ? org.id : null };
                            self.$axios.get(`/home/admin/my/tenant/clazz/stu/cal/score/0`, { params: params }).then(() => {
                                self.refresh();
                                self.$status('计算成功~', 'success');
                            });
                        }
                    });
                }
            }

            if (!iGl || a.orgType == 1) {
                acts.push({
                    label: '导出报表', func() {
                        let self = this;
                        window.open(`${self.$const.baseUrl}${url}/export/report/form/html?_clazzId=${self.cfg.params._clazzId}`, '_blank');
                    }
                }, {
                    label: '导出详情', func() {
                        let self = this, bUrl = self.$const.baseUrl, cid = self.cfg.params._clazzId,
                            oid = org ? org.id : self.$store.state.account.orgId, count = self.total;
                        self.$dialog.component('导出详情', ExportStatusViewer,
                            { width: 400, count: count, exeUrl: `${url}/export/details/execute?_count=${count}&_clazzId=${cid}&_orgId=${oid}`, downUrl: `${bUrl}${url}/export/details/download.zip?_clazzId=${cid}&_orgId=${oid}` });

                    }
                }, {
                    label: '未完成名单', func() {
                        let self = this;
                        this.$dialog.component('未完成名单', ClazzUnFinishedStu, { clazzId: self.cfg.params._clazzId });
                    }
                }, {
                    label: '导出月学习报表', func() {
                        let self = this;
                        self.$dialog.month('选择月份', {}, [{
                            label: '确认', color: 'primary', func(date) {
                                if (!date) return;
                                date = date.replaceAll('-', '');
                                window.open(`${self.$const.baseUrl}/home/admin/my/tenant/clazz/stu/export/month/report/form/pdf/${date}.pdf?_clazzId=${self.cfg.params._clazzId}`);
                            }
                        }]);
                    }
                });
            }
            if (canOpen && a.feeMode != 3) {
                if (!iGl || ((!a.orgId && org == null) || (org && org.type == 1))) {
                    acts.push({
                        whereSel: false,
                        label: '导入学员', func() {
                            self.$dialog.component('导入学员', SimpleUploader, {
                                width: 600,
                                persist: true,
                                url: `${url}/import?_clazzId=${self.cfg.params._clazzId}` + (org ? `&_orgId=${org.id}` : ''),
                                templateUrl: !iGl || org ? '/s/a/sc_import.xlsx' : '/s/a/sca_import.xlsx',
                                onUploadComplete(r) {
                                    let s = r.data.status, msg = r.data.message;
                                    if (s == 'ok') {
                                        self.$dialog.close();
                                        if (r.data.task) {
                                            self.$status(msg, 'success');
                                            self.$store.commit('rightDrawer', 'myTaskShow');
                                        } else {
                                            self.$status('导入成功！', 'success');
                                        }
                                    } else {
                                        if (typeof msg == 'string') {
                                            self.$dialog.close();
                                            self.$status(msg, 'error');
                                        } else {
                                            self.$status('导入错误，具体情况错误信息！', 'error');
                                            self.$dialog.component('导入错误信息', DataList, {
                                                width: 600,
                                                heads: [{ label: '行', name: 'row' }, { label: '列', name: 'col' }, { label: '说明', name: 'message' }],
                                                data: msg
                                            });
                                        }
                                    }
                                    self.refresh();
                                }
                            });
                        }
                    });
                }
                if (!iGl || a.orgType == 1) {
                    acts.push({
                        whereSel: false,
                        label: '添加学员', func() {
                            let self = this;
                            self.$dialog.crud('选择学员', { url: '/home/admin/my/tenant/stu', selectStyle: 'multi', params: { _orgId: org ? org.id : null }, createable: false, editable: false, deleteable: false }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    let ids = Object.keys(sel);
                                    if (ids.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`${url}/add/${ids.join('_')}`, { params: { _clazzId: self.cfg.params._clazzId, _orgId: org ? org.id : null } }).then(r => {
                                        self.refresh(false, true);
                                        if (r.data && r.data.status == 'ok') {
                                            //do nothing.
                                        } else {
                                            self.$status(r.data && r.data.message ? r.data.message : '添加学员不成功！', 'error');
                                        }
                                    });
                                }
                            }]);
                        }
                    });
                }
            }

            // start: 仅仅针对新疆
            if (!iGl && !archived && a.tenantId == 82 && a.originOrgId == 0) {
                //控制一下时间段
                let now = new Date();
                if (!(now.getHours() > 7 && now.getHours() < 22)) {
                    acts.push({
                        label: '导出定制学习记录', func() {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/clazz/stu/xinjiang/export?_clazzId=${self.cfg.params._clazzId}`).then(r => {
                                if (r.data.status == 'ok') {
                                    self.$status('导出已经加入到异步任务，请在异步任务中看导出状态并下载导出结果～', 'success');
                                    self.$store.commit('rightDrawer', 'myTaskShow');
                                    return;
                                }
                                self.$status(r.data.message || '导出错误～', 'error');
                            });
                        }
                    });
                }
            }
            // end: 仅仅针对新疆
            return acts;
        },
        listItemActions() {
            let acts = [{
                label: '学习详情', icon: 'more_horiz', func(cfg) {
                    let self = this;
                    self.$dialog.component(`学习详情 - ${cfg.item._name || cfg.item.name}`, 'stuclazz-view', { fullscreen: true, ruleId: self.$dictVal(cfg.item.ruleId), clazzId: self.$dictVal(cfg.item.clazzId), id: cfg.item.id, archived: cfg.item.archived });
                }
            },
            {
                label: '人脸识别', icon: 'face', func(cfg) {
                    let self = this;
                    self.$dialog.crud(`人脸识别 - ${cfg.item._name || cfg.item.name}`, {
                        url: '/home/admin/my/tenant/clazz/stu/face', params: { _stuClazzId: cfg.item.id, _arch: cfg.item.archived }, deleteable: !archived && !readonly && self.$isSuperman(),
                        listItemFilter(i, facts) {
                            let self = this;
                            if (archived || !self.$isSuperman()) {
                                self.delAction(facts, 'icon', 'face');
                            }
                            i.status._component = {
                                name: 'crud-list-avatar-item', cfg: {
                                    label: i.status.name,
                                    url: `${self.$const.baseUrl}/home/admin/my/tenant/clazz/stu/face/img/${i.path}?s=100x100&_arch=${i.archived}`,
                                    previewUrl: `${self.$const.baseUrl}/home/admin/my/tenant/clazz/stu/face/img/${i.path}?_arch=${i.archived}`
                                }
                            }
                            return facts;
                        },
                        fullscreen: true,
                        selectStyle: 'multi',
                        listActions() {
                            if (!archived && !readonly) {
                                return [{
                                    label: '设置通过', func() {
                                        let self = this, sel = Object.keys(self.selected());
                                        if (sel && sel.length > 0) {
                                            self.$axios.get(`/home/admin/my/tenant/clazz/stu/face/status/update/${sel.join('_')}/true`, { params: self.cfg.params }).then(() => {
                                                self.refresh(false, true);
                                            });
                                        }
                                    }
                                }, {
                                    label: '设置不通过', func() {
                                        let self = this, sel = Object.keys(self.selected());
                                        if (sel && sel.length > 0) {
                                            self.$axios.get(`/home/admin/my/tenant/clazz/stu/face/status/update/${sel.join('_')}/false`, { params: self.cfg.params }).then(() => {
                                                self.refresh(false, true);
                                            });
                                        }
                                    }
                                }];
                            }
                            return [];
                        },
                        listItemActions: readonly ? [] : [{
                            label: '设置为初始照片', icon: 'face', confirm: '确认将该照片设为初始比对照片吗？设置后将以该照片为比对基准，请确认照片清晰无误。', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/stu/face/to/idphoto/${cfg.item.id}`, { params: self.cfg.params, _arch: cfg.item.archived }).then(r => {
                                    r = r.data;
                                    if (r && r.status == 'ok') {
                                        self.$status('设置成功～', 'success');
                                        return;
                                    }
                                    self.$status(r && r.message ? r.message : '设置初始照片失败～', 'error');
                                });
                            }
                        }]
                    });
                }
            },
            {
                label: '导出详情', icon: 'save_alt', func(cfg) {
                    let self = this;
                    window.open(`${self.$const.baseUrl}${url}/export/detail/html/${cfg.item.id}?_clazzId=${self.cfg.params._clazzId}&_arch=${cfg.item.archived}`);
                }
            },
            {
                label: '导出证明', icon: 'chrome_reader_mode', func(cfg) {
                    let self = this;
                    window.open(`${self.$const.baseUrl}${url}/export/cert/html/${cfg.item.id}?_clazzId=${self.cfg.params._clazzId}&_arch=${cfg.item.archived}`);
                }
            },
            {
                label: '培训日志', icon: 'timeline', func(cfg) {
                    let self = this;
                    let a = self.$store.state.account, scId = cfg.item.id, crud = {
                        fullscreen: true,
                        editable: !archived && !readonly && (!!a.orgId || !iGl), url: '/home/admin/my/tenant/clazz/stulog', params: { _scId: scId, _arch: cfg.item.archived },
                        selectStyle: 'multi',
                        listActions: archived || readonly ? [] : [{
                            label: '重置推送状态', confirm: '确认将选中的日志状态重置为未推送吗？', whereSel: true, func() {
                                let self = this, sel = self.selected();
                                if (!sel) {
                                    return;
                                }
                                let ids = Object.keys(sel);
                                self.$axios.get(`/home/admin/my/tenant/clazz/stulog/status/reset/${ids.join('_')}?_scId=${scId}&_arch=${cfg.item.archived}`).then(() => {
                                    self.refresh(false, true);
                                });
                            }
                        }],
                        listItemActions: archived || readonly ? [] : [{
                            label: '重置状态到未推送', confirm: '确认将该条日志状态重置为未推送吗？', icon: 'restore', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/stulog/status/reset/${cfg.item.id}?_scId=${scId}&_arch=${cfg.item.archived}`).then(() => {
                                    self.refresh();
                                });
                            }
                        }],
                        listItemFilter(i, acts) {
                            let self = this, s = self.$dictVal(i.status);
                            if (s == 1 || s == 2) {
                                self.delAction(acts, 'icon', 'delete');
                                self.delAction(acts, 'icon', 'edit');
                                // self.delAction(acts, 'icon', 'restore');
                            }
                            return acts;
                        }
                    };
                    self.$dialog.crud(`培训日志 - ${cfg.item.name}`, crud);
                    return;
                }
            }];
            if (!archived) {
                acts.push(
                    {
                        label: '标记', icon: 'label_outline', func(cfg) {
                            let self = this;
                            self.$axios.get('/home/admin/my/tenant/clazz/stu/tags').then(r => {
                                let tags = r.data.message;
                                if (!tags || tags.length == 0) {
                                    self.$status('没有可用的标记字典', 'error');
                                    return;
                                }
                                self.$dialog.select(`标记学员 - ${cfg.item._name || cfg.item.name}`, { width: 400, items: tags, itemLabel: 'name', itemVal: 'id' }, [{
                                    label: '确认', color: 'primary', func(tagId) {
                                        if (tagId) {
                                            self.$axios.get(`/home/admin/my/tenant/clazz/stu/flag/tag/${cfg.item.id}/${tagId}`, { params: { _arch: cfg.item.archived, _orgId: org ? org.id : null, _clazzId: self.cfg.params._clazzId } }).then(() => {
                                                self.refresh();
                                                self.$status('标记成功～', 'success');
                                            });
                                        }
                                    }
                                }]);
                            });
                        }
                    },
                    {
                        label: '取消标记', icon: 'backspace', confirm: '确认要取消标记？', func(cfg) {
                            let self = this;
                            self.$axios.get(`/home/admin/my/tenant/clazz/stu/flag/tag/${cfg.item.id}/0`, { params: { _arch: cfg.item.archived, _orgId: org ? org.id : null, _clazzId: self.cfg.params._clazzId } }).then(() => {
                                self.refresh();
                                self.$status('取消标记成功', 'success');
                            });
                        }
                    }, {
                    label: '计算学习进度', icon: 'refresh', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/stu/cal/score/${cfg.item.id}`, { params: { _arch: cfg.item.archived, _clazzId: self.$dictVal(cfg.item.clazzId) } }).then(() => {
                            self.refresh();
                            self.$status('计算成功~', 'success');
                        });
                    }
                }, {
                    label: '设置学习时间', icon: 'schedule', func(cfg) {
                        let self = this;
                        self.$dialog.crud(`设置学习时间 - ${cfg.item._name || cfg.item.name}`, {
                            forceEditFormStretch: true,
                            url: '/home/admin/my/tenant/clazz/stu', initPanel: 'edit', editable: true, targetId: cfg.item.id, params: { _clazzId: self.$dictVal(cfg.item.clazzId), _chglearntime: true, _arch: cfg.item.archived },
                            onSaveSuccess() {
                                self.$dialog.close();
                                self.refresh();
                            }
                        });
                    }
                }, {
                    label: '学时作废', icon: 'block', confirm: '确认清除学习数据吗？', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/stu/scrap/${cfg.item.id}?_arch=${cfg.item.archived}`).then(r => {
                            if (r.data) {
                                if (r.data.status == "ok") {
                                    self.$status('操作成功', 'success');
                                    self.refresh();
                                } else {
                                    self.$status(r.data.message || "操作失败！", 'error');
                                }
                            }
                        });
                    }
                }, {
                    label: '删除选课记录', icon: 'delete', confirm: '确认删除选课记录吗？', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/stu/delete/${cfg.item.id}?_arch=${cfg.item.archived}`).then(r => {
                            if (r.data) {
                                if (r.data.status == "ok") {
                                    self.$status('操作成功', 'success');
                                    self.refresh();
                                } else {
                                    self.$status(r.data.message || "操作失败！", 'error');
                                }
                            }
                        });
                    }
                }, {
                    label: '删除未学习选课记录', icon: 'delete_sweep', confirm: '确认要删除未学习记录吗（如果已有学习进度不能删除）？', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/stu/unlearn/delete/${cfg.item.id}?_arch=${cfg.item.archived}`).then(r => {
                            if (r.data) {
                                if (r.data.status == "ok") {
                                    self.$status('操作成功', 'success');
                                    self.refresh();
                                } else {
                                    self.$status(r.data.message || "操作失败！", 'error');
                                }
                            }
                        });
                    }
                }, {
                    label: '关闭人脸识别', icon: 'toggle_on', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/stu/face/closed/${cfg.item.id}/${!cfg.item.closeFace}?_arch=${cfg.item.archived}`).then(() => {
                            self.$status('操作成功～', 'success');
                            self.refresh();
                        });
                    }
                }, {
                    label: '重新学习', icon: 'swap_calls', confirm: '确定设置重新学习吗？', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/my/tenant/clazz/stu/repeat/learn/${cfg.item.id}?_clazzId=${self.cfg.params._clazzId}`).then(() => {
                            self.$status('操作成功～', 'success');
                            self.refresh();
                        });
                    }
                }, {
                    label: '重学记录', icon: 'filter_list', func(cfg) {
                        let self = this;
                        self.$dialog.crud(`重学记录 - ${cfg.item._name || cfg.item.name}`, {
                            url: '/home/admin/my/tenant/clazz/stu/repeat', params: { _stuClazzId: cfg.item.id }
                        });
                    }
                });
            }
            return acts;
        },
        listItemFilter(i, acts, ctx) {
            let self = this, acc = self.$store.state.account, isSuper = self.$isSuperman(),
                isTenantSuper = self.$isInRole('ROLE_TENANT_SUPER'),
                canDelay = isTenantSuper || self.$isInRole('ROLE_TENANT_SC_DELAY'),
                canScrap = self.$isInRole('ROLE_SUPER') || (acc.orgType == 1 && self.$isInRole('ROLE_TENANT_SC_SCRAP')),
                relearn = acc.acceptRelearn && (isTenantSuper || self.$isInRole('ROLE_TENANT_SC_OPEN'));
            if (!trackLog) {
                self.delAction(acts, 'icon', 'timeline');
            }
            if (i.faceSuccess === undefined) {
                self.delAction(acts, 'icon', 'face');
                self.delAction(acts, 'icon', 'toggle_on');
            } else if (!isSuper) {
                self.delAction(acts, 'icon', 'toggle_on');
            } else {
                if (i.closeFace) {
                    let t = acts.find(i => i.icon == 'toggle_on');
                    t.icon = 'toggle_off';
                    t.label = '打开人脸识别';
                }
            }
            if (self.$dictVal(i.learnStatus) === 1) {
                self.delAction(acts, 'icon', 'chrome_reader_mode');
            }

            if (!canScrap) {
                self.delAction(acts, 'icon', 'block');
            }

            if (acc.feeMode != 1 || (!isSuper && !self.$isInRole('ROLE_TENANT_SC_DEL'))) {
                self.delAction(acts, 'icon', 'delete');
            }

            if (!isSuper && !self.$isInRole('ROLE_TENANT_SC_DEL_U')) {
                self.delAction(acts, 'icon', 'delete_sweep');
            }

            self.delAction(acts, 'icon', i.tagId ? 'label_outline' : 'backspace');

            if (!canDelay) {
                self.delAction(acts, 'icon', 'schedule');
            }

            if (i.group || self.$dictVal(i.resignStatus) == 1 || i.exceptionFlag) {
                let tCfg = [];
                if (i.group) {
                    let color = 'primary';
                    if (ctx) {
                        if (!ctx.colorHash) {
                            ctx.colorHash = {};
                        }
                        color = ctx.colorHash[i.group];
                        if (!color) {
                            if (!ctx.colors) {
                                ctx.colors = colors();
                            }
                            let idx = Math.floor(Math.random() * ctx.colors.length);
                            color = ctx.colors[idx];
                            ctx.colors.splice(idx, 1);
                            ctx.colorHash[i.group] = color;
                        }
                    }
                    tCfg.push({ val: i.name, flag: i.group, color: color });
                } else {
                    tCfg.push({ val: i.name });
                }

                if (self.$dictVal(i.resignStatus) == 1) {
                    tCfg.push({ flag: '离职', color: 'red' });
                }

                if (i.exceptionFlag) {
                    tCfg.push({ flag: '异常', color: 'red' });
                }

                i._name = i.name;

                i.name = {
                    _component: { name: RowFlag, cfg: tCfg }
                };
            }

            if (!relearn) {
                self.delAction(acts, 'icon', 'swap_calls');
                self.delAction(acts, 'icon', 'filter_list');
            } else if (!i.tryCount || i.tryCount < 2) {
                self.delAction(acts, 'icon', 'filter_list');
            }
            return acts;
        }
    };
    return cfg;
}

function clazzRouterChildren(iGl, readonly) {
    let c = [
        {
            path: 'stats/:_clazzId', component: ClazzChart, meta: { name: '统计分析' }
        },
        {
            path: 'stu/:_clazzId/:_archived/:_trackType', component: AutoRouter, meta() {
                let self = this, a = self.$store.state.account;
                if (!iGl || a.orgType == 1 || (!a.orgId && a.tenantOrgCount == 0)) {
                    return stuClazzCrudMeta(iGl, null, self.$route.params._archived, readonly, self.$route.params._trackType == 3);
                }
                return {
                    name: '学员管理', acceptEmptyActive: true, tree: orgTree(true), crud(i) { return stuClazzCrudMeta(iGl, i, self.$route.params._archived, readonly, self.$route.params._trackType == 3); }
                };
            }
        }, {
            path: 'comment/:_clazzId', component: CrudRouter, meta: {
                url: '/home/admin/my/tenant/clazz/comment',
                createable: false, editable: false,
                name: '评论管理',
                listItemActions() {
                    let acts = [{
                        label: '回复管理', icon: 'reply', func(cfg) {
                            let self = this;
                            self.$dialog.crud('回复管理', {
                                url: '/home/admin/my/tenant/clazz/comment', params: { _replyId: cfg.item.id, _clazzId: self.$route.params._clazzId },
                                editable: false, detailable: false,
                                listItemActions: readonly ? [] : [{
                                    label: '审核不通过', icon: 'visibility_off', func(cfg) {
                                        let self = this;
                                        self.$axios.get(`/home/admin/my/tenant/clazz/comment/status/${cfg.item.id}/${self.$dictVal(cfg.item.status) === 0 ? 1 : 0}`, { params: { _clazzId: self.cfg.params._clazzId } }).then(() => {
                                            self.refresh();
                                        });
                                    }
                                }, {
                                    label: '取消置顶', icon: 'vertical_align_bottom', func(cfg) {
                                        let self = this;
                                        self.$axios.get(`/home/admin/my/tenant/clazz/comment/top/${cfg.item.id}/${cfg.item.topTimestamp === 0 ? true : false}`, { params: { _clazzId: self.cfg.params._clazzId } }).then(() => {
                                            self.refresh();
                                        });
                                    }
                                }],
                                listItemFilter(i, acts) {
                                    if (this.$dictVal(i.status) === 0) {
                                        let act = acts.find(a => a.icon == "visibility_off");
                                        act.icon = "done";
                                        act.label = "审核通过";
                                    }
                                    if (i.topTimestamp === 0) {
                                        let act = acts.find(a => a.icon == "vertical_align_bottom");
                                        act.icon = "vertical_align_top";
                                        act.label = "置顶";
                                    }
                                    return acts;
                                }
                            })
                        }
                    }];
                    if (this.cfg.params._archived != 'true') {
                        acts.push({
                            label: '审核不通过', icon: 'visibility_off', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/comment/status/${cfg.item.id}/${self.$dictVal(cfg.item.status) === 0 ? 1 : 0}`, { params: { _clazzId: self.cfg.params._clazzId } }).then(() => {
                                    self.refresh();
                                });
                            }
                        }, {
                            label: '取消置顶', icon: 'vertical_align_bottom', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/comment/top/${cfg.item.id}/${cfg.item.topTimestamp === 0 ? true : false}`, { params: { _clazzId: self.cfg.params._clazzId } }).then(() => {
                                    self.refresh();
                                });
                            }
                        });
                    }
                    return acts;
                },
                listItemFilter(i, acts) {
                    if (this.$dictVal(i.status) === 0) {
                        let act = acts.find(a => a.icon == "visibility_off");
                        act.icon = "done";
                        act.label = "审核通过";
                    }
                    if (i.topTimestamp === 0) {
                        let act = acts.find(a => a.icon == "vertical_align_bottom");
                        act.icon = "vertical_align_top";
                        act.label = "置顶";
                    }
                    return acts;
                }
            }
        },
        {
            path: 'article/:_clazzId/:_archived', component: CrudRouter, meta: {
                url: '/home/admin/my/tenant/clazz/article',
                name: '阅读管理',
                createable() { return this.cfg.params._archived != 'true'; },
                editable() { return this.cfg.params._archived != 'true'; },
                deleteable() { return this.cfg.params._archived != 'true'; },
                listItemActions() {
                    let archived = this.cfg.params._archived == 'true', acts = [{
                        label: '预览', icon: 'visibility', func(cfg) {
                            let self = this;
                            self.$dialog.component("阅读预览", "article-view", {
                                id: cfg.item.id, params: { _clazzId: self.cfg.params._clazzId },
                                clazz: true
                            });
                        }
                    }
                    ];
                    if (!archived) {
                        acts.push({
                            label: '取消发布', icon: 'visibility_off', func(cfg) {
                                let self = this, status = self.$dictVal(cfg.item.status) === 0 ? 1 : 0;
                                function updateStatus(id, status, clazzId, joinExam) {
                                    self.$axios.get(`/home/admin/my/tenant/clazz/article/status/${id}/${status}`, { params: { _clazzId: clazzId, _joinExam: joinExam } }).then(r => {
                                        if (r.data && r.data.status == 'ok') {
                                            self.$status('操作成功！', 'success');
                                            self.refresh();
                                            return;
                                        }
                                        self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                                    });
                                }
                                if (!status) {
                                    updateStatus(cfg.item.id, status, self.cfg.params._clazzId);
                                    return;
                                }
                                //如果是发布，获取一下培训计划的信息并确认是否弹出对话框
                                self.$axios.get(`/home/admin/my/tenant/clazz/get/${self.cfg.params._clazzId}`).then(r => {
                                    if (r.data && r.data.status == 'ok') {
                                        let readJoinExam = r.data.message.readJoinExam;
                                        if (readJoinExam) {
                                            updateStatus(cfg.item.id, status, self.cfg.params._clazzId);
                                            return;
                                        }
                                        self.$dialog.component("阅读是否加入考核确认", DialogConfirmCheckbox, {
                                            text: '当前培训计划阅读不参与考核，请设置是否参与考核。',
                                            label: '设置为阅读参与考核',
                                            width: 400
                                        }, [{
                                            label: '确认', func: (c) => {
                                                readJoinExam = c === true ? true : undefined;
                                                updateStatus(cfg.item.id, status, self.cfg.params._clazzId, readJoinExam);
                                            }
                                        }]);
                                    }
                                })
                            }
                        }, {
                            label: '编辑内容', icon: 'description', func(cfg) {
                                let self = this;
                                self.$dialog.component(cfg.item.title, ClazzArticleEditor, {
                                    targetId: cfg.item.id,
                                    clazzId: self.cfg.params._clazzId,
                                    fullscreen: true,
                                    timestamp: Date.now()
                                });
                            }
                        }, {
                            label: '上传附件', icon: 'attachment', func(cfg) {
                                let self = this;
                                if (cfg.item.pdf) {
                                    self.$axios.post(`/home/admin/my/tenant/clazz/article/pdf/${cfg.item.id}`, self.$qs.stringify({ _clazzId: self.cfg.params._clazzId })).then(() => {
                                        self.refresh();
                                        self.$status('删除附件成功～', 'success');
                                    });
                                } else {
                                    self.$dialog.component('上传附件', SimpleUploader, {
                                        width: 600,
                                        persist: true,
                                        contentType: 'application/pdf',
                                        url: `/home/admin/my/tenant/clazz/article/upload/pdf?__entity_id=${cfg.item.id}&_clazzId=${self.cfg.params._clazzId}`,
                                        onUploadSuccess(r, fn) {
                                            if (r.data && r.data.success) {
                                                self.$axios.post(`/home/admin/my/tenant/clazz/article/pdf/${cfg.item.id}`, self.$qs.stringify({ _clazzId: self.cfg.params._clazzId, uuid: r.data.newUuid, fn: fn })).then(sr => {
                                                    if (sr.data && sr.data.status == 'ok') {
                                                        self.$dialog.close();
                                                        self.refresh();
                                                        self.$status('上传附件成功～', 'success');
                                                    }
                                                });
                                            }

                                        }
                                    });
                                }
                            }
                        }, {
                            label: '关联视频', icon: 'videocam', func(cfg) {
                                let self = this;
                                self.$dialog.crud('从收藏中选择视频', { url: '/home/my/favorite', params: { _type: 1 }, selectStyle: 'single' }, [{
                                    label: '确认添加', color: 'primary', func(sel) {
                                        if (!sel) {
                                            return;
                                        }
                                        let keys = Object.keys(sel);
                                        if (keys.length < 1) {
                                            return;
                                        }
                                        sel = sel[keys[0]];
                                        self.$axios.get(`/home/admin/my/tenant/clazz/article/video/${cfg.item.id}/${sel.targetId}`, { params: { _clazzId: self.cfg.params._clazzId } }).then(r => {
                                            if (r.data && r.data.status == 'ok') {
                                                self.$status('添加成功～', 'success');
                                                self.refresh();
                                            }
                                        });
                                    }
                                }]);
                            }
                        }, {
                            label: '取消关联的视频', icon: 'videocam_off', confirm: '确认要取消已经关联的视频？', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/article/video/${cfg.item.id}/0`, { params: { _clazzId: self.cfg.params._clazzId } }).then(r => {
                                    if (r.data && r.data.status == 'ok') {
                                        self.$status('取消成功～', 'success');
                                        self.refresh();
                                    }
                                });
                            }
                        }, {
                            label: '置顶', flag: 'top-up', icon: 'vertical_align_top', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/article/top/${cfg.item.id}/1`, { params: { _clazzId: self.cfg.params._clazzId } }).then(() => {
                                    self.refresh();
                                });
                            }
                        }, {
                            label: '取消置顶', flag: 'top-down', icon: 'vertical_align_bottom', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/article/top/${cfg.item.id}/0`, { params: { _clazzId: self.cfg.params._clazzId } }).then(() => {
                                    self.refresh();
                                });
                            }
                        }, {
                            label: '刷新阅读量', icon: 'forward_5', func(cfg) {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/article/cal/rn/${cfg.item.id}`).then(() => {
                                    self.refresh();
                                });
                            }
                        });
                    }
                    return acts
                },
                listActions() {
                    if (this.cfg.params._archived == 'true') {
                        return [];
                    }
                    let acts = [{
                        label: '添加阅读', func() {
                            let self = this;
                            self.$dialog.crud('从收藏中选择阅读', { url: '/home/my/favorite', params: { _type: 5 }, selectStyle: 'multi' }, [{
                                label: '确认添加', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    let ids = [];
                                    for (let v in sel) {
                                        let o = sel[v];
                                        ids.push(o.targetId);
                                    }
                                    if (ids.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/my/tenant/clazz/article/add/ga/${ids.join('_')}`, { params: { _clazzId: self.cfg.params._clazzId } }).then(r => {
                                        if (r.data && r.data.status == 'ok') {
                                            self.$status('操作成功！', 'success');
                                            self.refresh();
                                            return;
                                        }
                                        self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                                    });
                                }
                            }]);
                        }
                    }];
                    if (this.$isSuperman()) {
                        acts.push({
                            label: '刷新阅读成绩', func() {
                                let self = this;
                                self.$axios.get(`/home/admin/my/tenant/clazz/article/update/read/count/${self.cfg.params._clazzId}`).then(r => {
                                    if (r.data.status == 'ok') {
                                        self.$status('已添加到刷新列表！请不要重复点击刷新。具体查看处理结果请点击右上角下拉菜单中的异步任务查看。', 'success');
                                    }
                                });
                            }
                        })
                    }
                    return acts;
                },
                listItemFilter(i, acts) {
                    if (this.$dictVal(i.status) == 0) {
                        let act = acts.find(a => a.icon == "visibility_off");
                        act.icon = "done";
                        act.label = "发布";
                    }
                    if (this.$dictVal(i.videoId)) {
                        this.delAction(acts, "icon", "videocam");
                    } else {
                        this.delAction(acts, "icon", "videocam_off");
                    }
                    if (this.$dictVal(i.pdf)) {
                        let attachment = acts.find(a => a.icon == "attachment");
                        attachment.label = '删除附件';
                        attachment.confirm = '确认要删除附件吗？';
                        attachment.icon = 'link_off';
                    }

                    if (!i.topTs) {
                        this.delAction(acts, "flag", "top-down");
                    }
                    return acts;
                }
            }
        }
    ];
    if (iGl) {
        c.push({
            path: 'ctrl/:_clazzId/:_archived', component: CrudRouter, meta: {
                name: '分配机构',
                url: '/home/admin/my/tenant/clazz/ctrl',
                deleteable() { return this.cfg.params._archived != 'true'; },
                listActions() {
                    let archived = this.cfg.params._archived == 'true';
                    if (archived) {
                        return [];
                    }
                    return [{
                        label: '分配机构', func() {
                            let self = this, clazzId = self.cfg.params._clazzId;
                            self.$dialog.component('选择分配机构', TreeCrud, {
                                acceptEmptyActive: true, url: '/home/admin/my/tenant/org', tree: orgTree(true),
                                crud: { genParams(i) { return { _pid: i ? i.id : 0 } }, params: { _gl: true }, editable: false, deleteable: false, createable: false, selectStyle: 'multi' }
                            }, [{
                                label: '确认', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    sel = Object.keys(sel);
                                    if (sel.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/my/tenant/clazz/ctrl/add/${sel.join('_')}/true`, { params: { _clazzId: clazzId } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.$status('分配成功', 'success');
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "分配失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    }, {
                        label: '分配机构组', func() {
                            let self = this, clazzId = self.cfg.params._clazzId;
                            self.$dialog.crud('选择分组',
                                {
                                    url: '/home/admin/my/tenant/org/group', selectStyle: 'single',
                                    createable: false, editable: false, deleteable: false
                                }, [{
                                    label: '确认', color: 'primary', func(sel) {
                                        if (!sel) return;
                                        let ids = Object.keys(sel);
                                        if (ids.length == 0) return;
                                        self.$axios.get(`/home/admin/my/tenant/clazz/ctrl/group/add/${ids[0]}/true`, { params: { _clazzId: clazzId } }).then(r => {
                                            if (r.data && r.data.status == 'ok') {
                                                self.$status('分配成功～', 'success');
                                            } else {
                                                self.$status(r.data.message | '分配出现错误！', 'error');
                                            }
                                        });
                                    }
                                }]);
                        }
                    }, {
                        label: '禁用机构', func() {
                            let self = this, clazzId = self.cfg.params._clazzId;
                            self.$dialog.component('选择禁用机构', TreeCrud, { acceptEmptyActive: true, url: '/home/admin/my/tenant/org', tree: orgTree(true), crud: { genParams(i) { return { _pid: i ? i.id : 0 } }, params: { _gl: true }, editable: false, deleteable: false, createable: false, selectStyle: 'multi' } }, [{
                                label: '确认', color: 'primary', func(sel) {
                                    if (!sel) {
                                        return;
                                    }
                                    sel = Object.keys(sel);
                                    if (sel.length == 0) {
                                        return;
                                    }
                                    self.$axios.get(`/home/admin/my/tenant/clazz/ctrl/add/${sel.join('_')}/false`, { params: { _clazzId: clazzId } }).then(r => {
                                        if (r.data) {
                                            if (r.data.status == "ok") {
                                                self.$status('操作成功', 'success');
                                                self.refresh();
                                            } else {
                                                self.$status(r.data.message || "操作失败！", 'error');
                                            }
                                        }
                                    });
                                }
                            }]);
                        }
                    }, {
                        label: '禁用机构组', func() {
                            let self = this, clazzId = self.cfg.params._clazzId;
                            self.$dialog.crud('选择分组',
                                {
                                    width: 600, url: '/home/admin/my/tenant/org/group', selectStyle: 'single',
                                    createable: false, editable: false, deleteable: false
                                }, [{
                                    label: '确认', color: 'primary', func(sel) {
                                        if (!sel) return;
                                        let ids = Object.keys(sel);
                                        if (ids.length == 0) return;
                                        self.$axios.get(`/home/admin/my/tenant/clazz/ctrl/group/add/${ids[0]}/false`, { params: { _clazzId: clazzId } }).then(r => {
                                            if (r.data && r.data.status == 'ok') {
                                                self.$status('禁用成功～', 'success');
                                            } else {
                                                self.$status(r.data.message | '禁用出现错误！', 'error');
                                            }
                                        });
                                    }
                                }]);
                        }
                    }];
                }
            }
        });
    }
    return c;
}
const routers = [{
    path: 'home/admin/my/tenant/invitor', component: CrudRouter, meta: {
        listItemActions: [{
            label: '结算设置', icon: 'done', func(cfg) {
                this.$parent.onEdit(cfg.item.id, { _fee: true });
            }
        }, {
            label: '刷新数据', icon: 'refresh', func(cfg) {
                let self = this;
                self.$axios.get(`/home/admin/my/tenant/invitor/refresh/${cfg.item.id}`).then(() => {
                    self.refresh();
                });
            }
        }, {
            label: '引入购课记录', icon: 'list', func(cfg) {
                let self = this;
                self.$dialog.crud(`引入购课记录 - ${cfg.item.name}`, {
                    url: '/home/admin/my/tenant/invitor/order', params: { _invitor: cfg.item.id }, listActions: [{
                        label: '导出', func() {
                            let self = this,
                                params = { _invitor: cfg.item.id };
                            if (self.searching) {
                                params = { ...params, ...self.searchData() };
                            }
                            window.open(`${self.$const.baseUrl}/home/admin/my/tenant/invitor/order/export.xlsx?${self.$qs.stringify(params)}`);
                        }
                    }]
                });
            }
        }, {
            label: '分销二维码', icon: 'crop_free', func(cfg) {
                let self = this;
                self.$dialog.img('分销二维码', { desc: `<p style="text-align:center">${cfg.item.name}的二维码</p><p style="text-align:center">可以右击保存图片或截屏</p>`, src: `${self.$const.baseUrl}/home/admin/my/tenant/invitor/qrcode/${cfg.item.id}.png`, width: 360 });
            }
        }]
    }
}, {
    path: 'home/admin/my/tenant/g_clazz', component: CrudRouter, meta: {
        url: 'home/admin/my/tenant/clazz', params: { _global: 'true' }, ...clazzCrudMeta(true)
    },
    children: clazzRouterChildren(true)
},
{
    path: 'home/admin/my/tenant/clazz', component: CrudRouter, meta: clazzCrudMeta(false),
    children: clazzRouterChildren(false)
},
{
    path: 'home/admin/my/tenant/ro_clazz', component: CrudRouter, meta: {
        url: 'home/admin/my/tenant/clazz', ...clazzCrudMeta(false, true)
    },
    children: clazzRouterChildren(false, true)
},
{
    path: 'home/admin/my/tenant/g_ro_clazz', component: CrudRouter, meta: {
        url: 'home/admin/my/tenant/clazz', params: { _global: 'true' }, ...clazzCrudMeta(true, true)
    },
    children: clazzRouterChildren(true, true)
}, {
    path: 'home/admin/my/tenant/proto/clazz', component: CrudRouter, meta: {
        onEditSelect(e) {
            let self = this;
            if (e.field != 'ruleId') {
                return;
            }
            self.$dialog.crud('选择培训方案', { url: '/home/my/favorite', params: { _type: 6 }, selectStyle: 'single' }, [{
                label: '确认', color: 'primary', func(sel) {
                    if (sel) {
                        let keys = Object.keys(sel);
                        if (keys.length > 0) {
                            let o = sel[keys[0]];
                            e.cb(o.name, o.targetId);
                        }
                    }
                }
            }]);
        },
        listItemActions: [{
            label: '已创建的培训计划', icon: 'list', func(cfg) {
                this.$router.push(`/console/home/admin/my/tenant/proto/clazz/ins/${cfg.item.id}`, `已创建的培训计划 - ${cfg.item.name}`);
            }
        }],
        onEditFieldChange(fn, val, label) {
            let self = this;
            if (fn == 'ruleId' && label) {
                let nameVal = self.getFieldValue('name');
                if (!nameVal) {
                    self.setFieldValue('name', label);
                }
                return;
            }
        }
    },
    children: [
        {
            path: 'ins/:_pid', component: CrudRouter, meta: {
                name: '已创建的培训计划',
                url: '/home/admin/my/tenant/proto/clazz/ins',
                listActions: [{
                    label: '创建培训计划', func() {
                        let self = this, protoId = self.$route.params._pid;
                        self.$dialog.component('选择机构', TreeCrud, {
                            acceptEmptyActive: true, url: '/home/admin/my/tenant/org', tree: orgTree(true),
                            crud: {
                                genParams(i) { return { _pid: i ? i.id : 0 } }, params: { _gl: true },
                                editable: false, deleteable: false, createable: false, selectStyle: 'multi',
                                listItemFilter(i, acts) {
                                    if (i.type != 1) {
                                        i._selectable = false;
                                    }
                                    return acts;
                                }
                            }
                        }, [{
                            label: '确认', color: 'primary', func(sel) {
                                if (!sel) {
                                    return;
                                }
                                sel = Object.keys(sel);
                                if (sel.length == 0) {
                                    return;
                                }
                                self.$axios.get(`/home/admin/my/tenant/proto/clazz/do/gen/${protoId}/${sel.join('_')}`).then(r => {
                                    if (r.data) {
                                        if (r.data.status == "ok") {
                                            self.$status('创建成功', 'success');
                                            self.refresh();
                                        } else {
                                            self.$status(r.data.message || "创建失败！", 'error');
                                        }
                                    }
                                });
                            }
                        }]);
                    }
                }, {
                    label: '清空已创建培训计划', confirm: '确认要删除该模版下已创建的培训计划吗？', func() {
                        let self = this, protoId = self.$route.params._pid;
                        self.$axios.get(`/home/admin/my/tenant/proto/clazz/do/del/${protoId}`).then(() => {
                            self.refresh();
                        });
                    }
                }, {
                    label: '按组创建培训计划', func() {
                        let self = this, protoId = self.$route.params._pid;
                        self.$dialog.crud('选择分组',
                            {
                                url: '/home/admin/my/tenant/org/group', selectStyle: 'single',
                                createable: false, editable: false, deleteable: false
                            }, [{
                                label: '确认', color: 'primary', func(sel) {
                                    if (!sel) return;
                                    let ids = Object.keys(sel);
                                    if (ids.length == 0) return;
                                    self.$axios.get(`/home/admin/my/tenant/proto/clazz/group/do/gen/${protoId}/${ids[0]}`).then(r => {
                                        if (r.data && r.data.status == 'ok') {
                                            self.$status('创建成功～', 'success');
                                            self.refresh();
                                        } else {
                                            self.$status(r.data.message | '创建失败！', 'error');
                                        }
                                    });
                                }
                            }]);

                    }
                }]
            }
        }
    ]
}];
export default {
    routers: routers
}